import { Link } from "react-router-dom";
import { Coins, LogIn } from "lucide-react";
import { useCustomer } from "@/context/CustomerContext";

export const CustomerChip = () => {
  const { customer, login } = useCustomer();
  if (customer === null) return null;
  if (!customer) {
    return (
      <button onClick={login} className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border border-forest/30 text-forest text-sm font-semibold hover:bg-sage-100 transition-colors" data-testid="header-login-button">
        <LogIn className="w-4 h-4" /> Masuk
      </button>
    );
  }
  return (
    <Link to="/pesanan" className="inline-flex items-center gap-2 pl-1 pr-3 py-1 rounded-full bg-sage-100 border border-sage-200 hover:border-forest transition-colors" data-testid="header-customer-chip">
      {customer.picture ? <img src={customer.picture} alt="" className="w-7 h-7 rounded-full" referrerPolicy="no-referrer" /> : <span className="w-7 h-7 rounded-full bg-forest text-paper grid place-items-center text-xs font-bold">{customer.name[0]}</span>}
      <span className="flex items-center gap-1 text-sm font-semibold text-forest" data-testid="header-coin-balance"><Coins className="w-4 h-4 text-amber-600" />{customer.coins}</span>
    </Link>
  );
};
